/*========================================================================
* $Id: feedback.js -1M 2016-03-11 18:13:13Z (local) $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2021
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  "api/v2/api",
  "client/template",
  "utils/browser",
  "client/resourceinfo",
  "component!base",
  "i18n/i18n",
  "jquery",
  "underscore",
  "model/persisted_collection",
  "model/persisted_models",
  "service/stub",
  "backbone"
 ], function(
   API,
   Template,
   Browser,
   ResourceInfo,
   Base,
   i18n,
   $,
   _,
   PersistedCollection,
   PersistedModels,
   Stub,
   Backbone
 ) {
      Browser.loadCSS(ResourceInfo.scriptLocation + "../client/component/feedback/css/feedback.css", "feedback");

      var FeedbackModel = Backbone.Model.extend({
        toJSON: function() {
          var atts = this.attributes;
          var path = atts.path;
          return {
            path: path,
            data: JSON.stringify(atts.data),
            property: atts.property
          };
        }
      });

      var ResultFeedbackCollection = PersistedCollection.extend({
        model: FeedbackModel,
        usePaths: true,
        method: "list_resources",

        initialize: function (unused, options) {
          options = options || {};
          options.serviceStub = options.serviceStub || new Stub({path: "persistedresources"});
          PersistedCollection.prototype.initialize.apply(this, arguments);
          this.path = options.path;
        },

        parse: function(response) {
          _.each(response.persisted_resources, function(el) { el.id = el.path.join("/") });
          return response.persisted_resources;
        },

        sync: function( method, model, options ){
          arguments[0] = this.method;
          this.path = options.path;
          this.filter = options.filter;
          this.order_by = options.order_by;
          this.distinct_properties = options.distinct_properties;
          return this.syncMethod.apply(this, arguments);
        },

        get: function (key) {
          if (key === "length") {
            if (this.models.length) return this.models.length;
            return null;
          }
          return PersistedCollection.prototype.get.apply(this, arguments);
        }
      });

      var DocumentLabelsCollection;

      var FeedbackTemplate = Template.extend({
        initialize: function () {
          Template.prototype.initialize.apply(this, _.toArray(arguments));
        },

        createView: function(options) {
          var options = _.extend(this.schema.parseAttributes(this.attributeModel.getCamelCase()), options);
          return Template.prototype.createView.apply(this, [options]);
        },

        schema: new Template.Schema({
          attributes: {
            'enabled': {
              title: "feedback_component_enabled",
              type: "boolean",
              defaultValue: true
            },
            'label-property': {
              title: "feedback_component_label_property",
              type: "string"
            },
            'label-path': {
              title: "feedback_component_label_path",
              type: "string"
            },
            'feedback-path': {
              title: "feedback_component_feedback_path",
              type: "string"
            },
          }
        })
      });

      FeedbackTemplate.View = Base.extend({

        getDocumentLabelingLabelsPath: function() {
          if (this.options['label-path'] === undefined) {
            console.error('Template data-label-path attribute is missing. e.g data-label-path="labeldefinition/label"');
            return;
          }

          return this.options['label-path'];
        },

        getDocumentLabelingFeedbackPath: function() {
          if (this.options['feedback-path'] === undefined) {
            console.error('Template data-feedback-path attribute is missing. e.g data-feedback-path="itemdata/feedback"');
            return;
          }

          return this.options['feedback-path'];
        },

        getDocumentLabelingLabelProperty: function() {
          if (this.options['label-property'] === undefined) {
            console.error('Template data-label-property attribute is missing. e.g data-label-property="label"');
            return;
          }

          return this.options['label-property'];
        },

        getPersistedDocumentLabels: function (callback) {
          var path = this.getDocumentLabelingLabelsPath().split('/');

          DocumentLabelsCollection = new PersistedModels.PreviewFeedbackCollection(null, {
            channels: this.options.application.models.channels,
            appid: this.options.application.appid,
            path: path
          });

          DocumentLabelsCollection.fetch({
            success: function(collection, response) {
              var successResponse = response.status && response.status.success;
              callback(!successResponse);
            },
            error: function(response) {
              callback(true);
            }
          });
        },

        initialize: function () {
          var that = this;

          var searchDocumentLabelingLabelProperty = "properties." + that.getDocumentLabelingLabelProperty();
          this.model.set(searchDocumentLabelingLabelProperty, {formats: ["VALUE"]}, {silent: true});
        
          
          var documentLabelingEnabled = /^true$/i.test(this.options['enabled']);
         
          if (!documentLabelingEnabled) {
            this.init(true);
            return;
          }
          
          var that = this;
          this.getPersistedDocumentLabels(function (responseError) {
            that.init(responseError);
          });
        },

        init: function (doNotRenderFeedback) {
          Base.prototype.initialize.apply(this, arguments);
          if (doNotRenderFeedback) {
            return;
          }

          var that = this;
          this.actions = {};
          this.feedbackCollectionModels;

          this.collectionPath = this.getDocumentLabelingFeedbackPath().split('/');
          this.group = "feedback";
          this.dataKey = "predictedLabel";
          this.dataKeyDefault = "defaultPredictedLabel";

          this.documentLabels = _.map(DocumentLabelsCollection.models, function (model) {
            var data = model.attributes.data;
            return JSON.parse(data);
          });

          this.feedbackCollectionFetch = this.createFeedbackCollection();

          this.options.application.models.feedbackCollection = new Backbone.Collection();

          this.options.application.models.search.input.on("change", function(){
            that.options.application.models.feedbackCollection.reset();
          });

          this.model.output.loadTransformers.push(
            function(responseData) {
              return $.Deferred(function() {          
                var self = this;
                var currentResponseFilter = {"or": []};               
                _.each(responseData && responseData.resultset && responseData.resultset.results, function (result) {
                  if (result) {
                    that.prepareFilterObject(currentResponseFilter, result);
                  }
                });
                
                var localFeedbackCollection = that.createFeedbackCollection();

                localFeedbackCollection.fetch({
                  path: that.collectionPath,
                  filter: currentResponseFilter,
                  distinct_properties: [
                    "category",
                    "category_instance",
                    "key"
                  ],
                  order_by: [
                    { "asc": "category" },
                    { "asc": "category_instance" },
                    { "asc": "key" },
                    { "desc": "lastmod" }
                  ],
                  success: function(response, fullResponse) {
                    var isAnonymous = false;
                    if(fullResponse  && fullResponse.status && !fullResponse.status.success) {
                      // Ignore alert errors
                      delete fullResponse.status_messages;
                      isAnonymous = true;
                    }

                    that.prepareFeedbackCollectionFromResponseResults(responseData, localFeedbackCollection, isAnonymous);
                    self.resolve();
                  },
                  error: function(response) {
                    that.prepareFeedbackCollectionFromResponseResults(responseData);
                    self.resolve();
                  },
                });
              });
            }
          );
          
          this.options.application.views.on("afterRender:Result", function(application, view, model) {
            that.afterRenderResult(view, model);
          });

          this.options.application.createOrUpdateFeedback = this.options.application.createOrUpdateFeedback || _.bind(this.createOrUpdateFeedback, that);
          this.options.application.destroyFeedback = this.options.application.destroyFeedback || _.bind(this.destroyModel, that);
          this.onLoadOutput = _.bind(this.onLoadOutput, that);

          this.onLoadOutput();
        },

        prepareFeedbackCollectionFromResponseResults: function(responseData, feedbackCollection, isAnonymous) {
          var that = this;

          if (feedbackCollection) {
            feedbackCollection.forEach(function(model) {
              that.options.application.models.feedbackCollection.add(model);
            });
          }
          _.each(responseData && responseData.resultset && responseData.resultset.results, function (result) {
            if (result) {
              var itemKey = that.getPropertyValueFromResults("mes:key", result);
              var itemCategoryInstance = that.getPropertyValueFromResults("categoryinstance", result);
              var itemCategory = that.getPropertyValueFromResults("category", result);

              var persistedResultModelFound = that.getMatchingResultModelFromPersistedresource(
                that.options.application.models.feedbackCollection.models,
                itemKey,
                itemCategory,
                itemCategoryInstance
              );

              var feedbackLabel = that.getPropertyValueFromResults(that.getDocumentLabelingLabelProperty(), result);
    
              // Model already processed from persisted resources
              if (persistedResultModelFound) {
                persistedResultModelFound.set(that.dataKeyDefault, feedbackLabel || '');
                return;
              }

              
              if (!feedbackLabel) {
                feedbackLabel = '';
              }

              var data = {};
              data[that.dataKey] = feedbackLabel;

              var model = new FeedbackModel({
                isAnonymousFeedback: isAnonymous,
                path: that.collectionPath,
                data: data,
                property: [
                  { key: "category_instance", value: itemCategoryInstance },
                  { key: "category", value: itemCategory },
                  { key: "key", value: itemKey },
                  { key: "data_type", value: "application/json" }
                ]
              });
              that.appendModelToFeedbackCollection(model, feedbackLabel);
            }
          });
        },

        appendModelToFeedbackCollection: function(model, defaultFeedbackValue) {
          if (defaultFeedbackValue) {
            model.set(this.dataKeyDefault, defaultFeedbackValue);
          }
          this.options.application.models.feedbackCollection.add(model);
        },

        afterRenderResult: function (view, model) {
          if (this.options.application.models.feedbackCollection) {
            var key = model.get("mes:key"),
            category = model.get("category"),
            categoryinstance = model.get("categoryinstance");

            // check if the current rendered result is available in the list_resources persistedResource
            var feedbackItem = this.getMatchingResultModelFromPersistedresource(
              this.options.application.models.feedbackCollection.models,
              key,
              category,
              categoryinstance
            );

            if (feedbackItem) {
              view.$el.addClass("mb-feedback-resource");
              var isOwner = feedbackItem.get("is_owner");
              if (isOwner) {
                view.$el.addClass("mb-feedback-resource-admin");
              }
            }        
          }
        },

        getPropertyValueFromResults: function (key, result) {
          var property = _.find(result.properties, function(res) { return res.id == key });
          return property
                && property.data
                && property.data[0]
                && property.data[0].value
                && property.data[0].value.str;
        },

        prepareFilterObject: function (filter, result) {
          var key = this.getPropertyValueFromResults("mes:key", result);
          var category = this.getPropertyValueFromResults("category", result);
          var category_instance = this.getPropertyValueFromResults("categoryinstance", result);
          var filterItem = {
            "and": [{
              "eq": {
                "args": [{
                  "name": "category"
                }, {
                  "string_value": category
                }]
              }
            }, {
              "eq": {
                "args": [{
                  "name": "category_instance"
                }, {
                  "string_value": category_instance
                }]
              }
            }, {
              "eq": {
                "args": [{
                  "name": "key"
                }, {
                  "string_value": key
                }]
              }
            }]
          };
          filter.or.push(filterItem);
        },

        onLoadOutput: function() {
          var that = this;
          API.search.on("loadoutput", _.bind(function(model, atts, options) {
            
            if ( (atts && atts.resultset && atts.resultset.results) || (atts && atts.results) ) {
              _.each( (atts.resultset && atts.resultset.results) || atts.results, _.bind(function(result) {
                
                var resultPropertyValue = '';

                function getPropertyValueFromResults(key, resultItem) {
                  var property = resultItem.properties;
                  return property
                        && property[key]
                        && property[key].data
                        && property[key].data[0]
                        && property[key].data[0].value;
                };

                var key = getPropertyValueFromResults("mes:key", result);
                var categoryinstance = getPropertyValueFromResults("categoryinstance", result);
                var category = getPropertyValueFromResults("category", result);

                if (!key || !category || !categoryinstance) {
                  return;
                }
                
                var persistedResultModel = this.getMatchingResultModelFromPersistedresource(
                  that.options.application.models.feedbackCollection.models,
                  key,
                  category,
                  categoryinstance
                );
                
                var persistedData = persistedResultModel && persistedResultModel.get("data");
  
                var disableFeedbackSelectList = persistedResultModel && !!persistedResultModel.get("isAnonymousFeedback") || false;
                if (persistedData) {
                  try {
                    resultPropertyValue = JSON.parse(persistedData)[this.dataKey];
                  } catch (e) {
                    resultPropertyValue = persistedData[this.dataKey] || resultPropertyValue;
                  }
                }
                
                var actionName = "createOrUpdateFeedback";

                this.$el.append('<select data-action-object="{&quot;createOrUpdateFeedback&quot;:{&quot;actionType&quot;:&quot;vote&quot;, &quot;triggerValues&quot;:{&quot;html&quot;:&quot;up&quot;, &quot;pdf&quot;:&quot;down&quot;}}}" data-event-mask="change" aria-label="">  </select> ' +
                  '<button class="action mb-btn-no-decor mb-feedback-destroy" data-action-object="{&quot;destroyFeedback&quot;: {}}" title="Delete">' +
                  '<i class="icon-trash"></i> ' + i18n("action_remove") + '<span class="mb-acc">' + i18n("action_remove") + '</span> ' +
                  '</button>'
                );

                var action = this.$el.children();
                var lang = i18n.currentLocale();
                var $select = $(action[0]);
                
                $select.html("");

                var firstSelectOption = disableFeedbackSelectList ? 'N/A' : i18n("choose_from_options");
                $select.append('<option value="">'+ firstSelectOption +'</option>');

                _.each(this.documentLabels, function (label) {
                  var value = _.find(label.lang, function(val, key) {
                  var labelLang = key.split("-")[0]
                    return labelLang.toUpperCase() == lang.split("-")[0].toUpperCase()
                  });

                  var readableValue = value || label["en-US"] || label.labelId;
                  var value = label.labelId;
                  $select.append('<option value="'+ value +'">'+ readableValue +'</option>');
                });

                $($select).attr("disabled", disableFeedbackSelectList);
                $($select).find('option[value="'+ resultPropertyValue +'"]').attr("selected", true);

                var htmlAction = action[0].outerHTML + action[1].outerHTML;

                result.properties.actions && 
                result.properties.actions.data &&
                result.properties.actions.data.push({
                  "html": htmlAction,
                  "value": {
                    "action": {
                      actionName: {}
                    }
                  }
                });
                
                result.properties.actions &&
                result.properties.actions.properties && 
                result.properties.actions.properties.push({ 
                  "id": actionName,
                  "name": actionName,
                  "data": [{
                    "html": htmlAction,
                    "value": { "action": { actionName: {} }}
                  }]
                });

              }, this));
            }
          }, that));
        },

        getMatchingResultModelFromPersistedresource: function (collectionModels, key, category, categoryinstance) {
          var that = this;
          var persistedResourceModels = _.filter(collectionModels, function(persistedModel){
            var properties = persistedModel.get("property");

            return that.getValueFromListElement(properties, "category_instance") === categoryinstance &&
                  that.getValueFromListElement(properties, "category") === category && 
                  that.getValueFromListElement(properties, "key") === key;
          });

          return persistedResourceModels.length && persistedResourceModels[persistedResourceModels.length - 1];
        },

        destroyModel: function(options) {
          var that = this;
          var model = options.model;
          var key = model.get("mes:key"),
              category = model.get("category"),
              categoryinstance = model.get("categoryinstance");

          var persistedResultModel = this.getMatchingResultModelFromPersistedresource(
            this.options.application.models.feedbackCollection.models,
            key,
            category,
            categoryinstance
          );

          if (!persistedResultModel) return;
          persistedResultModel.destroy({
            success: function(model, response){
              // after remove item fetch again for older items for this specific result
              that.getResourceForResultItem(
                key,
                category,
                categoryinstance,
                model,
                {sender: options.sender}
              );
            },
            error: function(){

            },
            silent: true
          });
        },

        getResourceForResultItem: function (key, category, categoryinstance, destroyedModel, options) {
          var that = this;

          var filter = {
            "and": [{
              "eq": {
                "args": [{
                  "name": "category"
                }, {
                  "string_value": category
                }]
              }
            }, {
              "eq": {
                "args": [{
                  "name": "category_instance"
                }, {
                  "string_value": categoryinstance
                }]
              }
            }, {
              "eq": {
                "args": [{
                  "name": "key"
                }, {
                  "string_value": key
                }]
              }
            }]
          };

          $(options.sender.el).removeClass("mb-feedback-resource");
          $(options.sender.el).removeClass("mb-feedback-resource-admin");
          $(options.sender.el).find('option').removeAttr("selected");

          var localFeedbackCollection = this.createFeedbackCollection();
          var value = destroyedModel && destroyedModel.get(that.dataKeyDefault) || '';

          localFeedbackCollection.fetch({
            path: that.collectionPath,
            filter: filter,
            distinct_properties: ["category", "category_instance", "key"],
            order_by: [
              { "asc": "category" },
              { "asc": "category_instance" },
              { "asc": "key" },
              { "desc": "lastmod" }
            ],
            success: function(response) {
              localFeedbackCollection.forEach(function(model) {
                that.appendModelToFeedbackCollection(model, value);
              });

              try {
                var atts = response.models[0].attributes;
                if (atts.is_owner) {
                  $(options.sender.el).addClass("mb-feedback-resource-admin");
                }
                value = JSON.parse(atts.data).predictedLabel;
              } catch (e) {
                var data = {};
                data[that.dataKey] = value;

                var model = new FeedbackModel({
                  isAnonymousFeedback: true,
                  path: that.collectionPath,
                  data: data,
                  property: [
                    { key: "category_instance", value: categoryinstance },
                    { key: "category", value: category },
                    { key: "key", value: key },
                    { key: "data_type", value: "application/json" }
                  ]
                });
                that.appendModelToFeedbackCollection(model, value);
              }

              $(options.sender.el).find('option[value="'+ value +'"]').attr("selected", true);
            },
            error: function(response) {
              $(options.sender.el).find('option[value="'+ value +'"]').attr("selected", true);
            },
          });
        },

        createOrUpdateFeedback: function (options) {
          var model = options.model;
          var key = model.get("mes:key"),
              category = model.get("category"),
              categoryinstance = model.get("categoryinstance");
          
          var value = options.eventTarget.value;
          if (value === '') {
            this.destroyModel(options);
            return;
          }

          var resourceModel = this.getMatchingResultModelFromPersistedresource(
            this.options.application.models.feedbackCollection.models,
            key,
            category,
            categoryinstance
          );

          var isOwner = resourceModel && resourceModel.get("is_owner");
          var defaultFeedback = resourceModel && resourceModel.get(this.dataKeyDefault);

          var data = {};
          data[this.dataKey] = value; 

          if (resourceModel && isOwner) {
            // Update item
            resourceModel.set("data", data);
            resourceModel.save();
            $(options.sender.el).addClass("mb-feedback-resource mb-feedback-resource-admin");
          } else {
            // Create new feedback item
            var entry = new FeedbackModel({
              path: this.collectionPath,
              data: data,
              property: [
                { key: "category_instance", value: categoryinstance },
                { key: "category", value: category },
                { key: "key", value: key },
                { key: "is_owner", value: 'is_owner' },
                { key: "group", value: this.group },
                { key: "data_type", value: "application/json" }
              ]
            });

            var localFeedbackCollection = this.createFeedbackCollection();
            localFeedbackCollection.add(entry);
            this.appendModelToFeedbackCollection(entry, defaultFeedback);
            $(options.sender.el).addClass("mb-feedback-resource mb-feedback-resource-admin");
          }
        },

        createFeedbackCollection: function() {
          var localFeedbackCollection = new ResultFeedbackCollection(null, {
            channels: this.options.application.models.channels,
            appid: this.options.application.appid,
            path: this.collectionPath
          });

          return localFeedbackCollection;
        },

        getValueFromListElement: function (props, key) {
          var item = _.find(props, function(prop) { return prop.key === key });
          return item && item.value;
        },
      });

      return FeedbackTemplate;
});
